module.exports = __webpack_public_path__ + "img/913ef41.png";